import React, { useEffect } from 'react';
import { User } from '../../types';
import { socketService } from '../../services/socketService';
import {
  applyRemoteSupportPolicy,
  refreshRemoteSupportMe,
  resetRemoteSupportMe,
} from '../../services/remoteSupportService';
import { isTauri } from '../../utils/tauri';
import { RemoteSupportHost } from './RemoteSupportHost';
import { RemoteSupportOperator } from './RemoteSupportOperator';

/**
 * 원격지원 진입점 — App에 한 번 마운트한다(로그인 상태에서만).
 *
 *  - 담당자 여부·정책: 부팅·재연결·권한 변경(remote-support:me-changed)에 GET /api/remote-support/me,
 *    정책 변경은 소켓 config:remote-support로 받는다(socketService의 rs 허브)
 *  - 직원(화면을 내주는 쪽)은 PC 앱에서만 마운트한다 — 웹·모바일은 서버가 요청 대상에서 뺀다('rs-host' capability)
 *  - 담당자(보는 쪽)는 어디서든
 */
export const RemoteSupportRoot: React.FC<{ onOpenDm: (user: User) => void }> = ({ onOpenDm }) => {
  useEffect(() => {
    refreshRemoteSupportMe();
    const off = socketService.subscribeRemoteSupport((event, payload) => {
      if (event === 'config:remote-support') applyRemoteSupportPolicy(payload);
      else if (event === 'remote-support:me-changed' || event === 'rs:__connect') refreshRemoteSupportMe();
    });
    return () => {
      off();
      // 로그아웃 — 다음 계정에 이전 계정의 담당자 여부가 남지 않게
      resetRemoteSupportMe();
    };
  }, []);

  return (
    <>
      {isTauri() && <RemoteSupportHost />}
      <RemoteSupportOperator onOpenDm={onOpenDm} />
    </>
  );
};
